import classnames from "classnames";
import moment from "moment";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { filter_icon } from "../../../assets/images";
import { CLEAR_SEARCH_RESULT_FILTER, FILTER_INSTANT_RATE, SEARCH_RESULT_FILTER_UPDATE, UPDATE_SEARCH_INSTANT_RATE_DATA } from "../../../store/InstantRate/actionType";
import { filterInstantSearchAction } from "../../../store/InstantRate/actions";
import FilterSearchResult from "../../Sales/partials/FilterSearchResult";
import SearchResultCard from './SearchResultCard';
import Select from 'react-select';

export const inputArr = {
    carriers: [],
    agents: [],
    validity: '',
    charge_currency: "INR",
    to_charge_currency: { currencyCode: "INR" },
    from_charge_currency: { currencyCode: "USD" },
    exchange_rate: 83,

}

const SearchResultComp = ({ searchLocationFrom, QuoteModalHandler, searchResult, requestForRatesBtnAction, setRequestForRatesBtnAction }) => {
    const [activeTab, setactiveTab] = useState("all");
    const [isRight, setIsRight] = useState(false);
    const [filterLoader, setFilterLoader] = useState(false);
    const [carriersList, setCarriersList] = useState([]);

    const [filterDetails, setfilterDetails] = useState(inputArr);
    const { currency_data } = useSelector((state) => state?.globalReducer)

    const { quote_selected_data, instantSearchResultCopy, instantInquiryId, searchForm } = useSelector((state) => state.instantRate);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log(instantSearchResultCopy, "instantSearchResultCopy");
        let data = instantSearchResultCopy?.map((item) => {
            return item.carrierName
        })

        let uniqueArray = data?.filter((value, index, self) => self.indexOf(value) === index);
        setCarriersList(uniqueArray);


        let isPortToPort = (searchForm?.location_from.locationType === 'PORT' && searchForm?.location_to.locationType === 'PORT');
        let charges = [];
        if (isPortToPort) {
            charges = ['ORIGIN_LOCAL_PORT_CHARGES', 'FREIGHT_CHARGES', 'DESTINATION_LOCAL_PORT_CHARGES'];
        } else {
            charges = ['ORIGIN_INLAND_CHARGES', 'ORIGIN_LOCAL_PORT_CHARGES', 'FREIGHT_CHARGES', 'DESTINATION_LOCAL_PORT_CHARGES', 'DESTINATION_INLAND_CHARGES'];
        }

        setfilterDetails({ ...filterDetails, carriers: uniqueArray, charges });
    }, [instantSearchResultCopy]);
    const navToggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
        if (instantInquiryId !== '') {
            let url = `?ordering=${tab === 'preferred' ? 'PREFERRED' : tab === 'cheaper' ? 'CHEAPEST' : tab === 'faster' ? 'FASTEST' : 'DEFAULT'}&fclInquiryDetailId=${instantInquiryId}`;
            console.log(url);
            dispatch(filterInstantSearchAction(url));
        }
    };

    // right filter sidebar
    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const applyFilterHandler = () => {
        dispatch({ type: FILTER_INSTANT_RATE, payload: filterDetails });

        let carrierIds = instantSearchResultCopy?.map((item) => {
            if (filterDetails?.carriers?.includes(item.carrierName)) {
                return item.carrierId
            }
        }).filter(Boolean);
        let uniqueCarrierId = carrierIds.filter((value, index, self) => self.indexOf(value) === index);

        let startDate = filterDetails?.validity[0] !== undefined ? moment(filterDetails?.validity[0]).format('YYYY-MM-DD') : '';
        let endDate = filterDetails?.validity[1] !== undefined ? moment(filterDetails?.validity[1]).format('YYYY-MM-DD') : '';

        let url = '?'
        if (uniqueCarrierId.length > 0 || startDate || endDate || activeTab) {
            if (uniqueCarrierId.length > 0) {
                url += `carriers=${uniqueCarrierId}&`;
            }
            if (startDate !== '') {
                url += `startDate=${startDate}&`;
            }
            if (endDate !== '') {
                url += `endDate=${endDate}&`;
            }
            if (activeTab !== '') {
                url += `ordering=${activeTab === 'preferred' ? 'PREFERRED' : activeTab === 'cheaper' ? 'CHEAPEST' : activeTab === 'faster' ? 'FASTEST' : 'DEFAULT'}&`;
            }

            url += `fclInquiryDetailId=${instantInquiryId}`;
        }
        dispatch(filterInstantSearchAction(url));

        setTimeout(() => {
            dispatch({ type: SEARCH_RESULT_FILTER_UPDATE, payload: { obj: filterDetails?.charges } });
            setIsRight(false);
        }, 1000);
    }

    const clearValueHandler = () => {
        // setFilterLoader(true);
        setfilterDetails(inputArr);
        let url = '?'
        if (activeTab) {
            if (activeTab !== '') {
                url += `ordering=${activeTab === 'preferred' ? 'PREFERRED' : activeTab === 'cheaper' ? 'CHEAPEST' : activeTab === 'faster' ? 'FASTEST' : 'DEFAULT'}&`;
            }
            url += `fclInquiryDetailId=${instantInquiryId}`;
        }
        console.log(url, "clear url");
        dispatch(filterInstantSearchAction(url));
        setTimeout(() => {
            dispatch({ type: CLEAR_SEARCH_RESULT_FILTER });
            setIsRight(false);
        }, 1000);
    }

    const handleChangeHandler = (item, name) => {
        dispatch({ type: UPDATE_SEARCH_INSTANT_RATE_DATA, payload: { item, name } });
    }

    return (
        <>
            <div className="search_result_wrap">
                <div className="length_wrap">
                    <span>{instantSearchResultCopy?.length || 0} Search Results</span>

                    {/* {searchResult && <button type="button" className='btn btn-primary ms-auto quote_btn' onClick={QuoteModalHandler}
                        disabled={quote_selected_data?.length === 0}>Quote Now</button>} */}
                </div>
                <div className="result_tab_wrap">
                    <Nav pills className="navtab-bg nav-justified">
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === 'all', })} onClick={() => { navToggle("all"); }} >
                                All
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === 'preferred', })} onClick={() => { navToggle("preferred"); }} >
                                Preferred
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === "cheaper", })} onClick={() => { navToggle("cheaper"); }} >
                                Cheaper
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === "faster", })} onClick={() => { navToggle("faster"); }} >
                                Faster
                            </NavLink>
                        </NavItem>
                        <NavItem className="currency_wrap">

                            <Select
                                value={searchForm?.quote_currency}
                                options={currency_data ? currency_data?.map(({ value, currencyCode, id, version }) => ({ value, label: currencyCode, currencyCode, id, version })) : []}
                                classNamePrefix="select2-selection form-select"
                                onChange={(selectedOption) => {
                                    console.log(selectedOption, "selectedOption");
                                    selectedOption.is_quote_selected=true;
                                    handleChangeHandler(selectedOption, "quote_currency");
                                }}
                                placeholder="Select Currency"
                            />
                        </NavItem>
                        <NavItem className="filter_wrap">
                            <NavLink onClick={() => { toggleRightCanvas(); }} >
                                <img src={filter_icon} alt="filter" />
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>

                {activeTab === 'all' ? (
                    <SearchResultCard searchLocationFrom={searchLocationFrom} instantInquiryId={instantInquiryId} data={instantSearchResultCopy} QuoteModalHandler={QuoteModalHandler} requestForRatesBtnAction={requestForRatesBtnAction} setRequestForRatesBtnAction={setRequestForRatesBtnAction} />
                ) : activeTab === 'preferred' ? (
                    <SearchResultCard searchLocationFrom={searchLocationFrom} instantInquiryId={instantInquiryId} data={instantSearchResultCopy} QuoteModalHandler={QuoteModalHandler} requestForRatesBtnAction={requestForRatesBtnAction} setRequestForRatesBtnAction={setRequestForRatesBtnAction} />
                ) : activeTab === "cheaper" ? (
                    <SearchResultCard searchLocationFrom={searchLocationFrom} instantInquiryId={instantInquiryId} data={instantSearchResultCopy} QuoteModalHandler={QuoteModalHandler} requestForRatesBtnAction={requestForRatesBtnAction} setRequestForRatesBtnAction={setRequestForRatesBtnAction} />
                ) : (
                    <SearchResultCard searchLocationFrom={searchLocationFrom} instantInquiryId={instantInquiryId} data={instantSearchResultCopy} QuoteModalHandler={QuoteModalHandler} requestForRatesBtnAction={requestForRatesBtnAction} setRequestForRatesBtnAction={setRequestForRatesBtnAction} />
                    // <SearchResultCard data={resultData?.filter(item => item?.quote_type === 'faster')} QuoteModalHandler={QuoteModalHandler} />
                )}
            </div>
            {/* Filter Modal */}
            <FilterSearchResult isRight={isRight} filterLoader={filterLoader} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} carriersList={carriersList} />
        </>
    )
}

export default SearchResultComp
